/* dupe-quiz-v3.js — the L&P quiz-v2 screen engine on the דופרה tree (brands/dupes-il/quiz-v3-copy.md).
   Screens: gate → questions (blocks) with persuasion screens (blocks of type "screen") inserted → loader → result.
   Picking the 3 scents stays in dupe-quiz-engine.js (window.DupeQuizEngine). Config is the JSON in
   sections/dupe-quiz-v3.liquid ([data-dupe-quiz-v3]). The flow helpers are exported so node can test every path. */
(function (root) {
  'use strict';

  /* ───────── pure helpers (no DOM) ───────── */
  function lines(txt) { return String(txt || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean); }
  /* "text=sig:val,sig:val" → [text, {sig: val}] */
  function parseSignals(txt) {
    return lines(txt).map(function (l) {
      var p = l.split('='); var sig = {};
      (p[1] || '').split(',').forEach(function (kv) { var x = kv.trim().split(':'); if (x[0]) sig[x[0].trim()] = (x[1] || 'any').trim(); });
      return [p[0].trim(), sig];
    });
  }
  /* "text=>target" → [text, target]; a line without => goes to "next" */
  function parseRoutes(txt) {
    return lines(txt).map(function (l) { var p = l.split('=>'); return [p[0].trim(), (p[1] || 'next').trim()]; });
  }
  /* gift for the partner = the feminine path; for a father, brother or friend the buyer can be anyone, so 'giftn' reads for both */
  function pathOf(A) { return A && A.who === 'gift' ? (A.to === 'partner' ? 'gift' : 'giftn') : 'me'; }
  function visibleQuestions(Q, A) {
    return Q.filter(function (q) {
      if (!q.show) return true;
      return q.show.split(',').every(function (c) { var kv = c.split(':'); var k = kv[0].trim(); return A[k] === undefined || A[k] === (kv[1] || '').trim(); });
    });
  }
  function findScreen(cfg, kind, path) {
    var S = cfg.screens || [];
    return S.filter(function (s) { return s.kind === kind && s.path === path; })[0] || S.filter(function (s) { return s.kind === kind; })[0] || null;
  }
  /* the straight line through the quiz for the current answers: questions, the fact screen(s) after their question,
     then believe → obj → loader. catch / social / trial / rep are reached only by an answer's target. */
  function sequence(cfg, A) {
    var path = pathOf(A), seq = [];
    var vis = visibleQuestions(cfg.questions, A);
    vis.forEach(function (q, i) {
      seq.push({ id: 'q:' + q.key, type: 'question', q: q, qi: i, qt: vis.length });
      (cfg.screens || []).forEach(function (s) {
        if (s.kind === 'fact' && s.after === q.key && (s.path === path || !s.path)) seq.push({ id: 'fact', type: 'content', s: s });
      });
    });
    ['believe', 'obj'].forEach(function (kind) { var s = findScreen(cfg, kind, path); if (s) seq.push({ id: kind, type: 'content', s: s }); });
    seq.push({ id: 'proc', type: 'proc' });
    return seq;
  }
  function nextId(cfg, A, curId) {
    var seq = sequence(cfg, A);
    for (var i = 0; i < seq.length; i++) if (seq[i].id === curId) return seq[i + 1] ? seq[i + 1].id : 'proc';
    return seq[0].id;
  }
  /* resolve a screen id to what renders */
  function screenOf(cfg, A, id) {
    var seq = sequence(cfg, A), i;
    for (i = 0; i < seq.length; i++) if (seq[i].id === id) return seq[i];
    if (id === 'catch' || id === 'social' || id === 'trial' || id === 'believe' || id === 'obj' || id === 'fact') {
      var s = findScreen(cfg, id, pathOf(A)); return s ? { id: id, type: 'content', s: s } : null;
    }
    if (id === 'proc') return { id: 'proc', type: 'proc' };
    if (id === 'result' || id === 'rep' || id === 'rep_done') return { id: id, type: id };
    return null;
  }
  /* every path through the graph ends on result or rep_done, no dead end: used by the node test */
  function walkAll(cfg) {
    var ends = {}, screensSeen = {}, maxDepth = 0, paths = 0, problems = [];
    function answersFor(sc, A) {
      if (sc.type === 'question') {
        var q = sc.q, gift = pathOf(A) !== 'me';
        if (q.ref) return q.opts.map(function (o) { return { text: o[0], set: { ref: o[1].ref } }; });
        var list = parseSignals(gift && q.a_gift ? q.a_gift : q.a);
        if (q.multi) return list.map(function (an) { var v = an[1][q.key]; var set = {}; set[q.key] = [v]; return { text: an[0], set: set }; });
        return list.map(function (an) { return { text: an[0], set: an[1] }; });
      }
      if (sc.type === 'content') {
        if (sc.s.answers) return parseRoutes(sc.s.answers).map(function (r) { return { text: r[0], to: r[1] }; });
        var b = parseRoutes(sc.s.btn)[0]; return [{ text: b ? b[0] : 'המשך', to: b ? b[1] : 'next' }];
      }
      return [];
    }
    function step(id, A, depth, trail) {
      if (depth > 40) { problems.push('loop: ' + trail.join(' > ')); return; }
      if (depth > maxDepth) maxDepth = depth;
      screensSeen[id] = (screensSeen[id] || 0) + 1;
      var sc = screenOf(cfg, A, id);
      if (!sc) { problems.push('missing screen "' + id + '" after ' + trail.join(' > ')); return; }
      if (sc.type === 'proc') return step('result', A, depth + 1, trail.concat(id));
      if (sc.type === 'result' || sc.type === 'rep_done') { ends[sc.type] = (ends[sc.type] || 0) + 1; paths++; return; }
      if (sc.type === 'rep') return step('rep_done', A, depth + 1, trail.concat(id));
      var ans = answersFor(sc, A);
      if (!ans.length) { problems.push('no answers on "' + id + '" after ' + trail.join(' > ')); return; }
      ans.forEach(function (a) {
        var B = JSON.parse(JSON.stringify(A));
        if (a.set) Object.keys(a.set).forEach(function (k) { B[k] = a.set[k]; });
        var to = a.to || 'next';
        step(to === 'next' ? nextId(cfg, B, sc.id) : to, B, depth + 1, trail.concat(id + '[' + a.text.slice(0, 18) + ']'));
      });
    }
    step(sequence(cfg, {})[0].id, {}, 0, []);
    return { paths: paths, ends: ends, screens: screensSeen, maxDepth: maxDepth, problems: problems };
  }
  var pure = { parseSignals: parseSignals, parseRoutes: parseRoutes, visibleQuestions: visibleQuestions, sequence: sequence, nextId: nextId, screenOf: screenOf, walkAll: walkAll, findScreen: findScreen };
  if (typeof module !== 'undefined' && module.exports) { module.exports = pure; return; }
  root.DupeQuizV3 = pure;

  /* ───────── the page ───────── */
  var cfgEl = document.querySelector('[data-dupe-quiz-v3]'); if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {};
  var rootEl = document.getElementById('dq3'); if (!rootEl || !root.DupeQuizEngine) return;
  var $ = function (sel) { return rootEl.querySelector(sel); };
  var gateEl = $('[data-screen="gate"]'), appEl = $('[data-screen="quiz"]'), stage = $('[data-stage]'), bar = $('[data-bar]'), countEl = $('[data-count]'), backBtn = $('[data-back]');
  var POOL = C.pool || [];
  var A = {}, cur = '', backStack = [], current = [], smalls = [], completed = false, screensSeen = 0, tInt = null;
  var KEY = 'dq3_' + (C.variant || 'v3');
  /* ?mode=one (the product-page link): the result leads with ONE scent that is his, the set comes second. Without the
     param nothing changes. The gift path always gets the set. */
  var MODE = (function () { try { return new URLSearchParams(location.search).get('mode') === 'one' ? 'one' : 'set'; } catch (e) { return 'set'; } })();
  function one() { return A.mode === 'one' && pathOf(A) === 'me'; }

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  /* blank line = paragraph, single break = <br>, **x** = gold */
  function rich(t) {
    return String(t || '').trim().split(/\n{2,}/).map(function (p) {
      return '<p>' + p.replace(/\*\*(.+?)\*\*/g, '<span class="gold">$1</span>').replace(/\n/g, '<br>') + '</p>';
    }).join('');
  }
  function gift() { return pathOf(A) !== 'me'; }
  function tg(key) { var g = T[key + '_g'], n = T[key + '_n']; if (pathOf(A) === 'giftn' && n) return n; return gift() && g ? g : T[key]; }
  function names() { return current.map(function (x) { return x.title; }); }
  /* the originals he said he likes, named the way he says them ("קריד אוונטוס"): every text can carry {refs}, and a
     block's "ref_line" / a "_ref" text shows only to someone who picked at least one (the gift path never does) */
  function byHandle(h) { return POOL.filter(function (p) { return p.handle === h; })[0] || null; }
  function likedList() { return gift() ? [] : [].concat(A.ref || []).filter(function (h) { return h && h !== 'none'; }).map(byHandle).filter(Boolean); }
  function sayName(p) { return p.inspired || ((p.brand ? p.brand + ' ' : '') + (p.original || p.title)); }
  function likedNames() {
    var n = likedList().map(sayName);
    if (n.length > 3) return n.slice(0, 3).join(', ') + ' ' + (T.refs_more || '').replace('{n}', n.length - 3);
    if (n.length > 1) return n.slice(0, -1).join(', ') + ' ' + (T.refs_and || '') + n[n.length - 1];
    return n[0] || '';
  }
  function fillRefs(t) { return String(t || '').replace(/\{refs\}/g, likedNames()).replace(/\{n\}/g, likedList().length); }
  function refLine(t) { return t && likedList().length ? '<p class="dq3-refline">' + esc(fillRefs(t)) + '</p>' : ''; }
  function tr(key) { var r = T[key + '_ref']; return r && likedList().length ? fillRefs(r) : tg(key); }

  /* ───────── tracking: every tap, stamped with the variant; pixels only when present or configured ───────── */
  (function initPixels() {
    var P = C.pixels || {};
    try {
      if (P.meta && !root.fbq) {
        (function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(root, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        root.fbq('init', P.meta);
      }
      if (P.tiktok && !root.ttq) {
        (function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie']; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }; for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { var e = ttq._i[t] || []; for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; }; ttq.load = function (e, n) { var i = 'https://analytics.tiktok.com/i18n/pixel/events.js'; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {}; var o = d.createElement('script'); o.type = 'text/javascript'; o.async = !0; o.src = i + '?sdkid=' + e + '&lib=' + t; var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(o, a); }; ttq.load(P.tiktok); ttq.page(); })(root, document, 'ttq');
      }
    } catch (e) {}
  })();
  /* the same event goes to Meta from the browser (fbq) and from our server (C.capi.url), with one eventID, so Meta keeps one
     copy and still gets it when an ad blocker stops the browser pixel */
  function evId(n) { return n + '.' + Date.now().toString(36) + '.' + Math.random().toString(36).slice(2, 10); }
  function cookie(k) { var m = document.cookie.match('(?:^|; )' + k + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function fbc() {
    var c = cookie('_fbc'); if (c) return c;
    try { var id = new URLSearchParams(location.search).get('fbclid'); if (id) { c = 'fb.1.' + Date.now() + '.' + id; sessionStorage.setItem(KEY + '_fbc', c); return c; } return sessionStorage.getItem(KEY + '_fbc') || ''; } catch (e) { return ''; }
  }
  function capi(list) {
    var c = C.capi || {}; if (!c.url) return;
    var allow = String(c.events || '').split(',').map(function (x) { return x.trim(); });
    list = list.filter(function (x) { return allow.indexOf(x.e) > -1 || (x.e === 'Lead' && allow.indexOf('QuizLead') > -1); });
    if (!list.length) return;
    try { fetch(c.url, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ u: location.href.split('#')[0], fbp: cookie('_fbp'), fbc: fbc(), ev: list }) }).catch(function () {}); } catch (e) {}
  }
  function track(name, params) {
    var p = Object.assign({ quiz_variant: C.variant || 'v3', quiz_path: A && A.who ? pathOf(A) : '' }, params || {});
    var id = evId(name), sent = [{ e: name, id: id, cd: p }];
    try { (root.dataLayer = root.dataLayer || []).push(Object.assign({ event: name }, p)); } catch (e) {}
    try { if (root.fbq) root.fbq('trackCustom', name, p, { eventID: id }); } catch (e) {}
    try { if (root.ttq && root.ttq.track) root.ttq.track(name, p); } catch (e) {}
    try { if (root.gtag) root.gtag('event', name, p); } catch (e) {}
    if (name === 'QuizLead') {
      var lid = evId('Lead'), lp = { value: 0, currency: 'ILS' };
      try { if (root.fbq) root.fbq('track', 'Lead', lp, { eventID: lid }); } catch (e) {}
      sent.push({ e: 'Lead', id: lid, cd: lp });
    }
    capi(sent);
  }


  /* ───────── 24h: the set he got is kept in the browser, and the gate offers it back ───────── */
  function save(extra) {
    try { localStorage.setItem(KEY, JSON.stringify(Object.assign({ ts: Date.now(), deadline: deadline(), A: A, picks: current.map(function (x) { return { h: x.handle, role: x.role || '', fromRef: !!x.fromRef, near: x.near || '', hero: !!x.hero }; }), smalls: smalls.map(function (x) { return x.handle; }) }, extra || {}))); } catch (e) {}
  }
  function saved() { try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); return s && s.deadline > Date.now() && s.picks && s.picks.length ? s : null; } catch (e) { return null; } }
  function deadline() {
    var hours = parseFloat(T.timer_hours) || 24;
    try { var d = parseInt(localStorage.getItem(KEY + '_dl'), 10); if (!d || d < Date.now()) { d = Date.now() + hours * 3600000; localStorage.setItem(KEY + '_dl', String(d)); } return d; } catch (e) { return Date.now() + hours * 3600000; }
  }
  function startTimer() {
    clearInterval(tInt); var el = document.getElementById('dq3tmr'); if (!el) return;
    var tick = function () {
      var ms = deadline() - Date.now(); if (ms < 0) ms = 0;
      var h = String(Math.floor(ms / 3600000)).padStart(2, '0'), m = String(Math.floor(ms % 3600000 / 60000)).padStart(2, '0'), s = String(Math.floor(ms % 60000 / 1000)).padStart(2, '0');
      el.textContent = h + ':' + m + ':' + s;
    };
    tick(); tInt = setInterval(tick, 1000);
  }

  /* ───────── navigation ───────── */
  /* warm the cache for every picture the quiz will show, right after the page loads, so a picture
     question or a proof screen opens with its images already there (ישראל, 19.10: "נטען הרבה זמן") */
  function preloadPics() {
    var urls = [];
    (C.questions || []).forEach(function (q) { (q.pic_imgs || []).forEach(function (u) { if (u) urls.push(u); }); });
    (C.screens || []).forEach(function (s) { if (s.img) urls.push(s.img); });
    ((C.social || {}).imgs || []).concat(+(C.gallery || {}).count ? (C.gallery || {}).imgs || [] : []).forEach(function (u) { if (u) urls.push(u); });
    urls.forEach(function (u) { var im = new Image(); im.decoding = 'async'; im.src = u; });
  }
  if (document.readyState === 'complete') setTimeout(preloadPics, 300); else window.addEventListener('load', function () { setTimeout(preloadPics, 300); });

  function show(which) { gateEl.hidden = which !== 'gate'; appEl.hidden = which !== 'quiz'; root.scrollTo({ top: 0, behavior: 'smooth' }); }
  function start() { A = { mode: MODE }; current = []; smalls = []; completed = false; backStack = []; show('quiz'); track('QuizStart', {}); render(sequence(C, A)[0].id); }
  function clearAfter(key) {
    var vis = visibleQuestions(C.questions, A), after = false;
    vis.forEach(function (q) { if (after) delete A[q.key]; if (q.key === key) after = true; });
  }
  function go(id, fromId) {
    if (id === 'next') id = nextId(C, A, fromId || cur);
    if (id === 'GIFT') { goBundle(); return; }
    render(id);
  }
  function goBack() { var prev = backStack.pop(); if (prev) render(prev, true); }
  backBtn.addEventListener('click', goBack);

  function answerQuestion(sc, an, isMulti, sel) {
    var q = sc.q;
    clearAfter(q.key);
    if (isMulti) A[q.key] = sel.slice(); else if (q.ref) A.ref = an[1].ref; else Object.keys(an[1]).forEach(function (k) { A[k] = an[1][k]; });
    var label = String(an[0]).replace(/\s+/g, ' ').slice(0, 95);
    if (q.key === 'who' || q.key === 'to') track('QuizPath', { path: pathOf(A) });
    else track('QuizAnswer', { step: q.key, answer: isMulti ? sel.join('|') : label });
    go('next', sc.id);
  }

  /* ───────── render ───────── */
  function setHead(label, pct) { countEl.textContent = label || ''; bar.style.width = Math.max(0, Math.min(100, pct)) + '%'; }
  /* progress = the screen's place in the straight line through the quiz, so it never moves back (the fact screen
     used to be pinned at 50% from when it sat mid-quiz; after the last question that read as a step backwards) */
  function seqPct(id) {
    var seq = sequence(C, A), n = seq.length;
    for (var i = 0; i < n; i++) if (seq[i].id === id) return Math.round((i + 1) / (n + 1) * 90);
    return 93;
  }
  function render(id, isBack) {
    var sc = screenOf(C, A, id); if (!sc) return;
    clearInterval(tInt);
    if (!isBack && cur && cur !== id && cur !== 'proc') backStack.push(cur);
    backBtn.hidden = !backStack.length || id === 'result' || id === 'rep_done';
    cur = id;
    var h = '';
    if (sc.type === 'question') h = renderQuestion(sc);
    else if (sc.type === 'content') h = renderContent(sc);
    else if (sc.type === 'proc') { runProc(); return; }
    else if (sc.type === 'result') h = renderResult();
    else if (sc.type === 'rep') h = renderRep();
    else if (sc.type === 'rep_done') h = renderRepDone();
    swap(h);
    if (sc.type === 'question') bindQuestion(sc);
    if (sc.type === 'content') bindContent(sc);
    if (sc.type === 'result') bindResult();
    if (sc.type === 'rep') bindRep();
    if (sc.type === 'rep_done') { var b = $('[data-to-result]'); if (b) b.addEventListener('click', function () { render('result'); }); }
    if (sc.type === 'result' || sc.type === 'rep_done') startTimer();
    /* like L&P: the popup opens on the third screen, after two were answered */
    if ((sc.type === 'question' || sc.type === 'content') && ++screensSeen >= 3) maybePopup();
  }
  function swap(h) { stage.style.animation = 'none'; void stage.offsetWidth; stage.style.animation = ''; stage.innerHTML = h; root.scrollTo({ top: 0, behavior: 'smooth' }); }

  /* a slot that still has no picture: a dashed box in the final size with what goes there (setting ph) */
  function ph(cls, text) { return C.ph ? '<div class="dq3-ph ' + cls + '"><span>' + esc(text || '') + '</span></div>' : ''; }
  function nth(t, n) { return String(t || '').replace('{n}', n); }
  function socialGrid() {
    var S = C.social || {}, imgs = S.imgs || [], n = Math.max(imgs.length, C.ph ? (+S.count || 0) : 0), h = '';
    for (var i = 0; i < n; i++) h += imgs[i] ? '<img src="' + esc(imgs[i]) + '" alt="" loading="lazy">' : ph('dq3-ph--social', nth(S.hint, i + 1));
    return h ? '<div class="dq3-social">' + h + '</div>' : '';
  }
  function resultGallery() {
    var G = C.gallery || {}, imgs = G.imgs || [], n = Math.max(imgs.length, C.ph ? (+G.count || 0) : 0), h = '';
    if (!+G.count && !imgs.length) return '';
    for (var i = 0; i < n; i++) h += imgs[i] ? '<img src="' + esc(imgs[i]) + '" alt="" loading="lazy">' : ph('dq3-ph--gallery', nth(G.hint, i + 1));
    return h ? '<div class="dq3-gallery">' + h + '</div>' : '';
  }

  function renderQuestion(sc) {
    var q = sc.q, g = gift();
    setHead((T.count_fmt || 'שאלה {n} מתוך {t}').replace('{n}', sc.qi + 1).replace('{t}', sc.qt), seqPct(sc.id));
    var ans = q.ref ? q.opts.map(function (o) { return [o[0], { ref: o[1].ref }]; }) : parseSignals(g && q.a_gift ? q.a_gift : q.a);
    var sel = Array.isArray(A[q.key]) ? A[q.key] : [];
    var h = refLine(q.ref_line) + '<h2 class="dq3-q">' + esc(g && q.q_gift ? q.q_gift : q.q) + '</h2>';
    h += '<p class="dq3-hint' + (q.multi ? ' is-multi' : '') + '">' + esc(q.multi ? T.hint_multi : (A.who ? tg('hint_single') : T.hint_single_n || T.hint_single)) + '</p>';
    if (q.ref) {
      /* the known-scent question as a grid of small bottle pictures, four per row (ישראל, 9.10), the "other" answer under it */
      h += '<div class="dq3-refgrid">' + q.opts.map(function (o, n) {
        if (o[1].ref === 'none') return '';
        return '<button type="button" class="dq3-ref' + (sel.indexOf(o[1].ref) > -1 ? ' is-on' : '') + '" data-n="' + n + '"><span class="dq3-ref__img">' + (o[1].img ? '<img src="' + esc(o[1].img) + '" alt="" loading="lazy">' : '') + '</span><span class="dq3-ref__name">' + esc(o[1].name || o[0]) + '</span></button>';
      }).join('') + '</div>';
      h += '<div class="dq3-answers">' + q.opts.map(function (o, n) { return o[1].ref === 'none' ? '<button type="button" class="dupe-quiz__answer" data-n="' + n + '">' + esc(o[0]) + '</button>' : ''; }).join('') + (q.multi ? '<button type="button" class="dupe-btn dupe-btn--solid dq3-cont" data-cont' + (sel.length ? '' : ' disabled') + '>' + esc(T.cont || 'המשך') + '</button>' : '') + '</div>';
      return h;
    }
    h += '<div class="dq3-answers' + (q.pics ? ' dq3-answers--pics' : '') + '" data-answers>' + ans.map(function (an, n) {
      var v = q.ref ? an[1].ref : an[1][q.key], on = q.multi && sel.indexOf(v) > -1 ? ' is-on' : '';
      if (q.pics) {
        var src = (q.pic_imgs || [])[n], pic = src ? '<img src="' + esc(src) + '" alt="" decoding="async">' : ph('dq3-ph--pic', String(q.pic_hint || '').replace('{a}', an[0]));
        return '<button type="button" class="dupe-quiz__answer dq3-picopt' + on + '" data-n="' + n + '"><span class="dq3-picopt__img">' + pic + '</span><span class="dq3-picopt__t">' + esc(an[0]) + '</span></button>';
      }
      return '<button type="button" class="dupe-quiz__answer' + on + '" data-n="' + n + '">' + esc(an[0]) + '</button>';
    }).join('') + (q.multi ? '<button type="button" class="dupe-btn dupe-btn--solid dq3-cont" data-cont' + (sel.length ? '' : ' disabled') + '>' + esc(T.cont || 'המשך') + '</button>' : '') + '</div>';
    return h;
  }
  function bindQuestion(sc) {
    var q = sc.q, g = gift();
    var ans = q.ref ? q.opts.map(function (o) { return [o[0], { ref: o[1].ref }]; }) : parseSignals(g && q.a_gift ? q.a_gift : q.a);
    var sel = Array.isArray(A[q.key]) ? A[q.key].slice() : [];
    var btns = stage.querySelectorAll('.dupe-quiz__answer, .dq3-ref'), cont = stage.querySelector('[data-cont]');
    btns.forEach(function (b) {
      var n = +b.dataset.n, an = ans[n], v = q.ref ? an[1].ref : an[1][q.key];
      b.addEventListener('click', function () {
        if (q.multi && q.ref && v === 'none') { b.classList.add('picked'); setTimeout(function () { answerQuestion(sc, an, false); }, 140); return; }
        if (q.multi) {
          if (v === 'any') sel = sel.indexOf('any') > -1 ? [] : ['any'];
          else { var k = sel.indexOf(v); if (k > -1) sel.splice(k, 1); else if (!q.max || sel.length < q.max) sel.push(v); sel = sel.filter(function (x) { return x !== 'any'; }); }
          btns.forEach(function (bb, m) { var vv = q.ref ? ans[m][1].ref : ans[m][1][q.key]; bb.classList.toggle('is-on', sel.indexOf(vv) > -1); });
          A[q.key] = sel.slice(); if (cont) cont.disabled = !sel.length; return;
        }
        b.classList.add('picked'); setTimeout(function () { answerQuestion(sc, an, false); }, 140);
      });
    });
    if (cont) cont.addEventListener('click', function () { answerQuestion(sc, [sel.join('|'), {}], true, sel); });
  }

  function renderContent(sc) {
    var s = sc.s;
    setHead(s.label || '', seqPct(sc.id));
    var h = '';
    if (s.kind === 'believe' || s.kind === 'obj') h += refLine(s.ref_line) + '<h2 class="dq3-q">' + esc(s.h) + '</h2>';
    else {
      h += '<div class="dq3-copybox">' + (s.h ? '<div class="dq3-headline">' + esc(s.h) + '</div>' : '') + refLine(s.ref_line) + rich(s.copy) + '</div>';
      if (s.social) h += socialGrid();
      /* the proof slot, like L&P's figure under the copy: a customer video or a photo, set per screen in the editor */
      if (s.video) h += s.video_loop ? '<video class="dq3-fig dq3-fig--loop" data-scrollplay muted loop playsinline preload="auto" src="' + esc(s.video) + '#t=0.001"></video>' : '<video class="dq3-fig" controls playsinline preload="metadata" src="' + esc(s.video) + '"></video>';
      else if (s.img) h += '<img class="dq3-fig" src="' + esc(s.img) + '" alt="" loading="lazy">';
      else if (s.fig_hint) h += ph('dq3-ph--fig', s.fig_hint);
      if ((s.video || s.img) && s.caption) h += '<div class="dq3-figcap">' + esc(s.caption) + '</div>';
      if (s.offer) h += '<div class="dq3-offer">' + rich(s.offer) + '</div>';
      if (s.sub) h += '<div class="dq3-sub">' + esc(s.sub) + '</div>';
    }
    if (s.answers) h += '<div class="dq3-answers">' + parseRoutes(s.answers).map(function (r, n) { return '<button type="button" class="dupe-quiz__answer" data-n="' + n + '">' + esc(r[0]) + '</button>'; }).join('') + '</div>';
    else { var b = parseRoutes(s.btn)[0] || ['המשך', 'next']; h += '<button type="button" class="dupe-btn dupe-btn--solid dq3-cta" data-btn>' + esc(b[0]) + '</button>'; }
    return h;
  }
  /* a looping clip stands still on its first frame and starts when she begins to scroll (ישראל, 19.10: it should not
     pull the eye while she reads; she sees a picture, scrolls, and it comes alive). Threshold = setting loop_scroll_px. */
  var scrollOff = null;
  function armScrollPlay(v) {
    if (scrollOff) scrollOff();
    var need = +(T.loop_scroll_px || 60), base = null, done = false;
    function start() { if (done) return; done = true; off(); v.play().catch(function () {}); }
    function on() { if (base !== null && Math.abs((root.scrollY || 0) - base) >= need) start(); }
    function off() { root.removeEventListener('scroll', on); scrollOff = null; }
    root.addEventListener('scroll', on, { passive: true });
    scrollOff = function () { done = true; off(); };
    /* the screen change scrolls to the top on its own, so the baseline is taken after that settles;
       a screen too short to scroll starts the clip after a short beat */
    setTimeout(function () {
      base = root.scrollY || 0;
      if (document.documentElement.scrollHeight - root.innerHeight < need) setTimeout(start, 1500);
    }, 800);
  }
  function bindContent(sc) {
    var s = sc.s;
    var lv = stage.querySelector('[data-scrollplay]'); if (lv) armScrollPlay(lv); else if (scrollOff) scrollOff();
    if (s.answers) {
      var routes = parseRoutes(s.answers);
      stage.querySelectorAll('.dupe-quiz__answer').forEach(function (b) {
        b.addEventListener('click', function () {
          var r = routes[+b.dataset.n];
          var label = String(r[0]).replace(/\s+/g, ' ').slice(0, 95);
          if (s.kind === 'obj') { A._objection = label; track('QuizObjection', { objection: label }); }
          else track('QuizAnswer', { step: s.kind, answer: label });
          b.classList.add('picked'); setTimeout(function () { go(r[1], sc.id); }, 140);
        });
      });
    } else {
      var b2 = parseRoutes(s.btn)[0] || ['המשך', 'next'];
      stage.querySelector('[data-btn]').addEventListener('click', function () { track('QuizAnswer', { step: s.kind, answer: 'continue' }); go(b2[1], sc.id); });
    }
  }

  /* loader: the engine picks while the messages run */
  function runProc() {
    backBtn.hidden = true; setHead('', 96);
    var steps = lines(((one() && T.one_think_steps) || tr('think_steps') || '').replace(/\|/g, '\n'));
    stage.innerHTML = '<div class="dq3-proc"><span class="dupe-quiz__spin" aria-hidden="true"></span><h2 class="dupe-h2">' + esc((one() && T.one_think_title) || T.think_title || '') + '</h2><p class="dq3-procmsg" aria-live="polite">' + esc(steps[0] || '') + '</p><div class="dq3-procbar"><i></i></div></div>';
    ensurePicks();
    var i = 0, every = parseInt(T.think_ms, 10) || 1200, pb = stage.querySelector('.dq3-procbar i'), pm = stage.querySelector('.dq3-procmsg');
    var step = function () {
      pb.style.width = ((i + 1) / Math.max(1, steps.length) * 100) + '%'; pm.textContent = steps[i] || '';
      i++; if (i < steps.length) setTimeout(step, every); else setTimeout(function () { cur = 'proc'; render('result'); }, every * .7);
    };
    step();
  }
  function ensurePicks() {
    if (current.length) return;
    var a = { who: A.who, know: A.know, when: A.when || [], season: A.season, char: A.char || [], strength: A.strength, ref: [].concat(A.ref || []).filter(function (x) { return x && x !== 'none'; }), want: A.want };
    a.bother = A.bother;
    current = root.DupeQuizEngine[one() ? 'pickOne' : 'pick'](POOL, a, { bestsellers: lines((T.bestsellers || '').replace(/,/g, '\n')), n: parseInt(T.set_count, 10) || 3 });
    smalls = root.DupeQuizEngine.pickSmall(POOL, a, current.map(function (x) { return x.handle; }), parseInt(T.one_small_count, 10) || 2);
  }
  function roleLabel(r) { return r === 'day' ? T.role_day : r === 'evening' ? T.role_evening : T.role_season; }
  /* both scents got the same role (he only asked for the day, or only for the evening): "each has its role" is not true then */
  function sameRole() { return current.length > 1 && current[0].role && current.every(function (x) { return x.role === current[0].role; }) ? current[0].role : ''; }
  function resultCopy() {
    if (likedList().length > 3 && T.result_copy_more) return fillRefs(T.result_copy_more);
    var r = sameRole(), liked = likedList().length;
    var same = !r ? '' : liked ? T.result_copy_ref_same : tg('result_copy_same');
    if (same) return (liked ? fillRefs(same) : same).replace('{role}', roleLabel(r));
    return tr('result_copy');
  }
  function resultVideo() {
    var V = C.result_video || {};
    return V.url ? '<div class="dq3-resvid"><video src="' + esc(V.url) + '"' + (V.poster ? ' poster="' + esc(V.poster) + '"' : '') + ' muted loop playsinline autoplay preload="metadata"></video></div>' : '';
  }
  function whyLine() {
    var map = {}; lines(T.why).concat(sameRole() ? lines(T.why_same) : []).forEach(function (l) { var p = l.split('='); if (p[0] && p[1]) map[p[0].trim()] = p[1].trim(); });
    var w = map[A.want] || map.any || '', suf = tg('why_suffix');
    return ((T.why_prefix || '') + ' ' + w).trim() + (suf ? (w ? '. ' : ' ') + suf : '');
  }
  function setHtml() {
    return current.map(function (f, n) {
      /* a scent he named says so; a fill in the character of one he named says which */
      var nr = f.near ? byHandle(f.near) : null, liked = likedList().length;
      var tag = !liked ? '' : f.fromRef && T.ref_why ? T.ref_why.replace('{original}', sayName(byHandle(f.handle) || f)) : nr && T.near_why ? T.near_why.replace('{original}', sayName(nr)) : '';
      return '<div class="dupe-quiz__item dq3-item" data-i="' + n + '"><span class="dupe-quiz__rank">' + (n + 1) + '</span><span class="dupe-quiz__img">' + (f.img ? '<img src="' + esc(f.img) + '" alt="">' : '') + '</span><span class="dupe-quiz__name">' + esc(f.title) + '</span>' + (f.role ? '<span class="dupe-quiz__role">' + esc(roleLabel(f.role)) + '</span>' : '') + '<span class="dupe-quiz__whyline">' + (tag ? '<span class="dq3-reftag">' + esc(tag) + '</span>' : '') + '<span class="dupe-quiz__why">' + esc(f.why || '') + '</span>' + (T.hours_line ? ' <span class="dupe-quiz__hours">' + esc(T.hours_line) + '</span>' : '') + '</span></div>';
    }).join('');
  }
  /* one-scent result: why THIS scent, in the words he answered with. A line shows only when the scent's own tag
     backs it (time / season / character / strength / compliments), so no reason is claimed that the catalog does not hold. */
  function reasons(h) {
    var p = root.DupeQuizEngine.norm(h), out = [], used = {};
    var map = {}; lines(T.one_reasons).forEach(function (l) { var i = l.indexOf('='); if (i > 0) map[l.slice(0, i).trim()] = l.slice(i + 1).trim(); });
    /* {why} = the scent's own short line (custom.quiz_why), so the reason names what it actually smells like */
    function add(k, group) { if (map[k] && !used[group] && out.length < (parseInt(T.one_reasons_max, 10) || 3)) { used[group] = 1; out.push(map[k].replace('{why}', h.why || map.why_fallback || '')); } }
    if (h.fromRef && T.ref_why) { used.ref = 1; out.push(T.ref_why.replace('{original}', sayName(byHandle(h.handle) || h))); }
    var strongish = p.strength === 'strong' || p.strength === 'mid';
    if (A.bother === 'fades' && strongish) add('bother_fades', 'last');
    if (A.bother === 'heavy' && p.strength !== 'strong') add('bother_heavy', 'light');
    if (A.bother === 'unnoticed' && p.compliments) add('bother_unnoticed', 'react');
    var chars = (A.char || []).filter(function (c) { return c !== 'any'; });
    if (chars.indexOf(p.char) > -1) add('char_' + p.char, 'char');
    var w = (A.when || []).filter(function (x) { return x !== 'any'; }), day = w.indexOf('day') > -1, eve = w.indexOf('evening') > -1 || w.indexOf('special') > -1;
    if (day && eve && p.time === 'both') add('when_both', 'when');
    else if (day && !eve && p.time !== 'evening') add(p.time === 'both' ? 'when_day_both' : 'when_day', 'when');
    else if (eve && !day && p.time !== 'day') add(p.time === 'both' ? 'when_evening_both' : 'when_evening', 'when');
    if (A.strength && A.strength !== 'any' && A.strength === p.strength) add('strength_' + p.strength, 'strength');
    if ((A.season === 'summer' || A.season === 'winter') && p.season === A.season) add('season_' + A.season, 'season');
    if (A.want === 'lasting' && strongish) add('want_lasting', 'last');
    if (A.want === 'light' && p.strength !== 'strong') add('want_light', 'light');
    if (A.want === 'react' && p.compliments) add('want_react', 'react');
    if (!out.length && map.unsure) out.push(map.unsure);
    return out;
  }
  function tile(f, small) { var pic = (small && (f.img_small || (byHandle(f.handle) || {}).img_small)) || f.img; return '<div class="dq3-row3__item' + (f.hero ? ' is-hero' : '') + '"><span class="dq3-row3__img">' + (pic ? '<img src="' + esc(pic) + '" alt="">' : '') + '</span><span class="dq3-row3__name">' + esc(f.title) + '</span>' + ((byHandle(f.handle) || f).inspired ? '<span class="dq3-row3__insp">' + esc(((T.one_insp_prefix || '') + ' ' + (byHandle(f.handle) || f).inspired).trim()) + '</span>' : '') + (!small && f.role ? '<span class="dq3-row3__role">' + esc(roleLabel(f.role)) + '</span>' : '') + '</div>'; }
  function smallsHtml() {
    if (!smalls.length) return '';
    var copy = tg('one_small_copy');
    return '<div class="dq3-plus dq3-plus--small"><div class="dq3-plus__h">' + esc(T.one_small_title) + '</div>' + (copy ? '<p class="dq3-plus__p">' + esc(copy) + '</p>' : '') + '</div><div class="dq3-row3 dq3-row3--small dq3-row3--n' + smalls.length + '">' + smalls.map(function (f) { return tile(f, true); }).join('') + '</div>';
  }
  function renderResultOne() {
    setHead(T.one_label || T.result_label || '', 100);
    var hero = current[0], rest = current.slice(1), src = byHandle(hero.handle) || hero;
    var h = '<div class="dq3-copybox dq3-copybox--result"><div class="dq3-headline">' + esc(T.one_title) + '</div></div>';
    h += '<div class="dq3-hero1">' + (hero.img ? '<span class="dq3-hero1__img"><img src="' + esc(hero.img) + '" alt=""></span>' : '') + '<div class="dq3-hero1__body"><div class="dq3-hero1__name">' + esc(hero.title) + '</div>' + (src.inspired ? '<div class="dq3-hero1__insp">' + esc(((T.one_insp_prefix || '') + ' ' + src.inspired).trim()) + '</div>' : '') + (T.one_why_title ? '<div class="dq3-hero1__why">' + esc(T.one_why_title) + '</div>' : '') + '<ul class="dq3-hero1__reasons">' + reasons(hero).map(function (r) { return '<li>' + esc(r) + '</li>'; }).join('') + '</ul></div></div>';
    if (rest.length) {
      h += '<div class="dq3-plus"><div class="dq3-plus__h">' + esc(T.one_plus_title) + '</div>' + (T.one_plus_copy ? '<p class="dq3-plus__p">' + esc(T.one_plus_copy) + '</p>' : '') + '</div>';
      /* the hero is already on top, so the row holds only what completes it (ישראל, 1.11) */
      h += '<div class="dq3-row3 dq3-row3--n' + rest.length + '" data-set>' + rest.map(function (f) { return tile(f, false); }).join('') + '</div>';
      h += smallsHtml();
    }
    h += '<div class="dq3-price"><span class="dq3-price__new">' + esc(T.price_new) + '</span><s class="dq3-price__old">' + esc(T.price_old) + '</s></div>';
    if (T.price_line) h += '<p class="dq3-priceline">' + esc(T.price_line) + '</p>';
    if (T.save_line) h += '<p class="dq3-save">' + esc(T.save_line) + '</p>';
    /* the two bundle-only gifts, shown: a photo of the gift with its line, and the free delivery under it */
    if (T.one_gift_title) h += '<div class="dq3-gift2">' + (T.one_gift_only ? '<div class="dq3-gift2__only">' + esc(T.one_gift_only) + '</div>' : '') + '<div class="dq3-gift2__row">' + (C.gift_img ? '<span class="dq3-gift2__img"><img src="' + esc(C.gift_img) + '" alt="" loading="lazy" onerror="this.parentNode.hidden=true"></span>' : '') + '<div class="dq3-gift2__txt"><b>' + esc(T.one_gift_title) + '</b><span>' + esc(T.one_gift_sub || '') + '</span></div></div>' + (T.one_gift_ship ? '<div class="dq3-gift2__ship"><svg viewBox="0 0 32 32" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9h15v13H3z"/><path d="M18 13h6l5 5v4h-11z"/><circle cx="9" cy="23.5" r="2.5"/><circle cx="23" cy="23.5" r="2.5"/></svg><span>' + esc(T.one_gift_ship) + '</span></div>' : '') + '</div>';
    else if (T.one_gift_block || T.gift_block) h += '<div class="dq3-gift">' + rich(T.one_gift_block || T.gift_block) + '</div>';
    if (tg('result_offer')) h += '<div class="dq3-offer">' + rich(tg('result_offer')) + '</div>';
    if (T.timer_label) h += '<div class="dq3-timer">⏳ ' + esc(T.timer_label) + ' <b id="dq3tmr">00:00:00</b></div>';
    h += '<button type="button" class="dupe-btn dupe-btn--solid dq3-cta dq3-cta--buy" data-add>' + esc(T.one_add_label || tg('add_label')) + '</button>';
    if (T.one_single_link && hero.url) h += '<a class="dupe-btn dupe-btn--ghost dq3-cta dq3-single" href="' + esc(hero.url) + '" data-single>' + esc(T.one_single_link.replace('{name}', hero.title)) + '</a>' + (T.one_single_note ? '<p class="dq3-single__note">' + esc(T.one_single_note) + '</p>' : '');
    if (T.badges) h += '<div class="dq3-badges">' + lines(T.badges.replace(/\|/g, '\n')).map(function (b) { return '<span>' + esc(b) + '</span>'; }).join('') + '</div>';
    if (T.rep_link) h += '<button type="button" class="dq3-textlink" data-rep>' + esc(T.rep_link) + '</button>';
    return h;
  }
  function renderResult() {
    ensurePicks();
    if (one() && current.length) return renderResultOne();
    setHead(T.result_label || '', 100);
    var h = '<div class="dq3-copybox dq3-copybox--result"><div class="dq3-headline">' + esc(tr('result_title')) + '</div>' + rich(resultCopy()) + '<p class="dq3-why">' + esc(whyLine()) + '</p></div>';
    h += '<div class="dupe-quiz__set" data-set>' + setHtml() + '</div>';
    h += smallsHtml();
    /* what he got first, then how it arrives, then the price (ישראל, 1.11) */
    h += resultVideo() || resultGallery();
    h += '<div class="dq3-price"><span class="dq3-price__new">' + esc(T.price_new) + '</span><s class="dq3-price__old">' + esc(T.price_old) + '</s></div>';
    if (T.save_line) h += '<p class="dq3-save">' + esc(T.save_line) + '</p>';
    if (T.price_line) h += '<p class="dq3-priceline">' + esc(T.price_line) + '</p>';
    if (T.gift_block) h += '<div class="dq3-gift">' + rich(T.gift_block) + '</div>';
    if (tg('result_offer')) h += '<div class="dq3-offer">' + rich(tg('result_offer')) + '</div>';
    if (T.timer_label) h += '<div class="dq3-timer">⏳ ' + esc(T.timer_label) + ' <b id="dq3tmr">00:00:00</b></div>';
    h += '<button type="button" class="dupe-btn dupe-btn--solid dq3-cta dq3-cta--buy" data-add>' + esc(tg('add_label')) + '</button>';
    if (T.badges) h += '<div class="dq3-badges">' + lines(T.badges.replace(/\|/g, '\n')).map(function (b) { return '<span>' + esc(b) + '</span>'; }).join('') + '</div>';
    if (T.rep_link) h += '<button type="button" class="dq3-textlink" data-rep>' + esc(T.rep_link) + '</button>';
    return h;
  }
  function bundleUrl() { var u = C.bundle.url || '/'; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'quiz=' + encodeURIComponent(names().join('|')) + (smalls.length ? '&small=' + encodeURIComponent(smalls.map(function (x) { return x.title; }).join('|')) : ''); }
  function bindResult() {
    if (!completed) {
      completed = true;
      track('QuizComplete', { model: names().join(' + '), objection: A._objection || '', mode: one() ? 'one' : 'set' });
      stampCart();
    }
    save();
    $('[data-add]').addEventListener('click', goBundle);
    var rep = $('[data-rep]'); if (rep) rep.addEventListener('click', function () { render('rep'); });
    var single = $('[data-single]'); if (single) single.addEventListener('click', function () { track('QuizSingleClick', { model: current[0] ? current[0].title : '' }); });
  }
  /* the answers ride on the order: cart attributes (and the bundle line carries the 3 names) */
  function attrs() {
    var o = {};
    o['Quiz variant'] = C.variant || 'v3'; o['Quiz path'] = pathOf(A); o['Quiz to'] = A.to || ''; o['Quiz set'] = names().join(' + ');
    o['Quiz objection'] = A._objection || ''; o['Quiz liked'] = likedList().map(sayName).join(' | '); o['Quiz want'] = A.want || ''; o['Quiz know'] = A.know || '';
    o['Quiz mode'] = one() ? 'one' : 'set'; o['Quiz small'] = smalls.map(function (x) { return x.title; }).join(' + '); o['Quiz bother'] = A.bother || '';
    o['Quiz when'] = (A.when || []).join('|'); o['Quiz season'] = A.season || ''; o['Quiz char'] = (A.char || []).join('|'); o['Quiz strength'] = A.strength || '';
    return o;
  }
  function stampCart() { try { fetch(C.routes.update, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs() }) }).catch(function () {}); } catch (e) {} }
  /* "זה המארז שלי": to the bundle page with the three marked, where he can still swap and adds to the cart himself
     (ישראל, 9.10: like the watches, whose button lands on the collection, not in the cart) */
  function goBundle() {
    var btn = $('[data-add]'); if (btn) btn.disabled = true;
    ensurePicks();
    track('QuizGiftClick', { model: names().join(' + ') });
    stampCart();
    save({ sent: true });
    setTimeout(function () { location.href = bundleUrl(); }, 250);
  }

  /* WhatsApp instead of a lead form: the set he got rides in the message */
  function waUrl() {
    ensurePicks();
    var txt = (tr('wa_text') || '').replace('{set}', names().join(', '));
    return C.wa ? 'https://wa.me/' + C.wa + '?text=' + encodeURIComponent(txt) : (C.routes.contact || '/pages/contact');
  }
  function renderRep() {
    setHead(T.rep_label || '', 98);
    return '<div class="dq3-copybox"><div class="dq3-headline">' + esc(T.rep_title) + '</div>' + rich(tg('rep_copy')) + '</div><a class="dupe-btn dupe-btn--solid dq3-cta" data-wa href="' + esc(waUrl()) + '" target="_blank" rel="noopener">' + esc(T.rep_btn) + '</a>';
  }
  function bindRep() { $('[data-wa]').addEventListener('click', function () { track('QuizLead', {}); stampCart(); save({ lead: true }); setTimeout(function () { render('rep_done'); }, 300); }); }
  function renderRepDone() {
    setHead('', 100);
    return '<div class="dq3-copybox"><div class="dq3-headline">' + esc(T.repdone_title) + '</div>' + rich(T.repdone_copy) + '<p><a class="dq3-textlink" href="' + esc(waUrl()) + '" target="_blank" rel="noopener">' + esc(T.repdone_link) + '</a></p></div><button type="button" class="dupe-btn dupe-btn--solid dq3-cta" data-to-result>' + esc(T.repdone_back) + '</button>';
  }

  /* the popup after the second screen: what waits at the end */
  function maybePopup() {
    if (!C.popup) return;
    try { if (sessionStorage.getItem(KEY + '_pop')) return; sessionStorage.setItem(KEY + '_pop', '1'); } catch (e) {}
    setTimeout(function () {
      var ov = document.createElement('div'); ov.className = 'dq3-pop';
      ov.innerHTML = '<div class="dq3-pop__card"><div class="dq3-pop__icon">🎁</div><div class="dq3-pop__h">' + esc(tg('popup_title')) + '</div><div class="dq3-pop__p">' + rich(tg('popup_text')) + '</div><button type="button" class="dupe-btn dupe-btn--solid dq3-pop__btn">' + esc(tg('popup_btn')) + '</button></div>';
      var close = function () { ov.remove(); };
      ov.querySelector('.dq3-pop__btn').addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      document.addEventListener('keydown', function esc_(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc_); } });
      document.body.appendChild(ov);
      track('QuizPopup', {});
    }, 150);
  }

  /* ───────── gate ───────── */
  $('[data-start]').addEventListener('click', start);
  (function resume() {
    var s = saved(); var link = $('[data-resume]'); if (!s || !link) return;
    link.hidden = false;
    link.addEventListener('click', function (e) {
      e.preventDefault(); A = s.A || {};
      current = s.picks.map(function (pk) { var h = pk && pk.h ? pk.h : pk; var p = POOL.filter(function (x) { return x.handle === h; })[0]; return p ? Object.assign({}, p, { role: pk && pk.role ? pk.role : '', fromRef: !!(pk && pk.fromRef), near: pk && pk.near ? pk.near : '', hero: !!(pk && pk.hero) }) : null; }).filter(Boolean);
      if (!A.mode) A.mode = 'set';
      smalls = (s.smalls || []).map(byHandle).filter(Boolean);
      if (current.length < 3) { current = []; }
      backStack = []; completed = true; show('quiz'); track('QuizResume', {}); cur = 'proc'; render('result');
    });
  })();
  track('QuizView', {});
  if (new URLSearchParams(location.search).get('start') === '1') start();
})(typeof window !== 'undefined' ? window : this);
